import React from 'react'

export function Stake({ stake, x, y, fontSize }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' x={x} width={55} y={y} height='21' viewBox='0 0 49 21' xmlSpace='preserve'>
			<g mask='url(#mask0_2936_72805)'>
				<circle cx='7' cy='10.5' r='6.5' fill='#303034' />
			</g>

			<rect x='15.5' y='3.5' width={34} height='14' rx='6.5' fill='#D9D9D9' style={{ opacity: 0.3 }} />
			<text
				fill='#fff'
				fontSize={fontSize || '8px'}
				fontWeight='400'
				x='67%'
				y='54%'
				dominantBaseline='middle'
				textAnchor='middle'
			>
				{stake?.toFixed(2)}
			</text>
		</svg>
	)
}

export const StakeComponent = React.memo(Stake)
